/** Presentation policy, not authorization. A narrow desktop window remains usable. */
export function isMobileBrowser(device: {
  userAgent: string;
  platform: string;
  maxTouchPoints: number;
  userAgentData?: { mobile: boolean };
} = typeof navigator === 'undefined' ? { userAgent: '', platform: '', maxTouchPoints: 0 } : navigator): boolean {
  return device.userAgentData?.mobile === true || /Android|iPhone|iPad|iPod/i.test(device.userAgent) ||
    (device.platform === 'MacIntel' && device.maxTouchPoints > 1);
}

export interface AppDownloadLinks { android?: string; ios?: string }
/** App URLs are public build configuration. Never invent store IDs/URLs. */
export function appDownloadLinks(android: unknown, ios: unknown): AppDownloadLinks {
  const checked = (value: unknown): string | undefined => {
    if (typeof value !== 'string' || !value) return undefined;
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : undefined;
    } catch { return undefined; }
  };
  return { android: checked(android), ios: checked(ios) };
}

/** Guest CSAT and meeting links stay usable; embed widgets use a separate entry. */
export function isGuestPublicPath(path: string): boolean {
  return /^\/(?:csat|meet)\/[^/]+\/?$/.test(path);
}
